import { render, staticRenderFns } from "./myRoom.vue?vue&type=template&id=117b67f0&scoped=true"
import script from "./myRoom.vue?vue&type=script&lang=js"
export * from "./myRoom.vue?vue&type=script&lang=js"
import style0 from "./myRoom.vue?vue&type=style&index=0&id=117b67f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117b67f0",
  null
  
)

export default component.exports